import { render, staticRenderFns } from "./comments-page.vue?vue&type=template&id=c1810b6e&scoped=true"
import script from "./comments-page.vue?vue&type=script&lang=js"
export * from "./comments-page.vue?vue&type=script&lang=js"
import style0 from "./comments-page.vue?vue&type=style&index=0&id=c1810b6e&prod&lang=less&scoped=true"
import style1 from "./comments-page.vue?vue&type=style&index=1&id=c1810b6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1810b6e",
  null
  
)

export default component.exports